import React from 'react';
import { Shield, Brain, Cloud, Code, Database, Lock } from 'lucide-react';
export function Services() {
  const services = [{
    icon: <Brain className="w-8 h-8" data-id="element-142" />,
    title: 'AI Solutions',
    description: 'Leverage the power of Artificial Intelligence to automate processes, gain insights, and drive innovation.',
    color: 'from-blue-500 to-cyan-400'
  }, {
    icon: <Shield className="w-8 h-8" data-id="element-143" />,
    title: 'Cybersecurity',
    description: 'Protect your digital assets with our advanced security protocols, threat detection, and risk assessment.',
    color: 'from-orange-500 to-red-500'
  }, {
    icon: <Cloud className="w-8 h-8" data-id="element-144" />,
    title: 'Cloud Services',
    description: 'Scalable cloud infrastructure solutions that ensure high availability, security, and performance.',
    color: 'from-purple-500 to-pink-500'
  }, {
    icon: <Code className="w-8 h-8" data-id="element-145" />,
    title: 'Software Development',
    description: 'Custom software solutions tailored to your specific business needs, built with modern technologies.',
    color: 'from-green-500 to-emerald-400'
  }, {
    icon: <Database className="w-8 h-8" data-id="element-146" />,
    title: 'Data Analytics',
    description: 'Transform raw data into actionable intelligence with our advanced analytics and visualization services.',
    color: 'from-indigo-500 to-blue-500'
  }, {
    icon: <Lock className="w-8 h-8" data-id="element-147" />,
    title: 'Security Consulting',
    description: 'Expert guidance on security compliance, policy development, and security architecture design.',
    color: 'from-yellow-500 to-orange-500'
  }];
  return <section id="services" className="py-24 bg-[#f8fafc] relative" data-id="element-148">
      <div className="container mx-auto px-4 md:px-6" data-id="element-149">
        <div className="text-center mb-20" data-id="element-150">
          <span className="text-[#f59e0b] font-bold tracking-wider uppercase text-sm bg-[#f59e0b]/10 px-4 py-2 rounded-full" data-id="element-151">
            What We Do
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0a1628] mt-6 mb-6" data-id="element-152">
            Our Services
          </h2>
          <p className="text-gray-600 mt-6 max-w-2xl mx-auto text-lg" data-id="element-153">
            Comprehensive technology solutions designed to empower your business
            and secure your future.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-154">
          {services.map((service, index) => <div key={index} className="group relative bg-white p-8 rounded-2xl shadow-sm hover:shadow-2xl transition-all duration-500 border border-gray-100 overflow-hidden cursor-pointer" data-id="element-155">
              {/* Hover Gradient Border Effect */}
              <div className={`absolute top-0 left-0 w-full h-1 bg-gradient-to-r ${service.color} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500`} data-id="element-156"></div>

              <div className="relative z-10" data-id="element-157">
                <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${service.color} flex items-center justify-center text-white mb-6 shadow-lg transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-500`} data-id="element-158">
                  {service.icon}
                </div>

                <h3 className="text-2xl font-bold text-[#0a1628] mb-4 group-hover:text-[#f59e0b] transition-colors duration-300" data-id="element-159">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-160">
                  {service.description}
                </p>
              </div>

              {/* Background Blob on Hover */}
              <div className={`absolute -bottom-10 -right-10 w-40 h-40 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-10 rounded-full blur-3xl transition-all duration-700`} data-id="element-161"></div>
            </div>)}
        </div>
      </div>
    </section>;
}